import React from 'react';
import { useTranslation } from '@shared/core';
import { DottedButton } from '@shared/components/DottedButton/DottedButton';

type WebsiteV2BackToSiteLinkProps = Readonly<{
  eventHandle: string;
  /** Event-derived text color for an event-themed surface; the shared link color otherwise. */
  color?: string;
}>;

/**
 * The way back to a Website V2 site from a Joy-owned guest page (registry, cash fund). Those pages
 * would otherwise show the charm site's V1 page nav, which a V2 site doesn't have.
 */
export const WebsiteV2BackToSiteLink: React.FC<WebsiteV2BackToSiteLinkProps> = ({ eventHandle, color }) => {
  const { tq } = useTranslation('websiteV2Guest');
  return (
    <DottedButton
      label={tq`Back to Site`}
      href={`/${eventHandle}`}
      testId="website-v2-back-to-site"
      buttonStyles={color ? { color } : undefined}
    />
  );
};
